import type { SVGProps } from 'react';
const DawnFlagAO = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-AO_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-AO_svg__a)">
      <path fill="url(#dawn-flag-AO_svg__b)" d="M0 0h22v16H0z" />
      <g filter="url(#dawn-flag-AO_svg__c)">
        <path
          fill="#262626"
          fillRule="evenodd"
          d="M0 16h22V8.533H0z"
          clipRule="evenodd"
        />
      </g>
      <g filter="url(#dawn-flag-AO_svg__d)">
        <path fill="#DD2137" fillRule="evenodd" d="M0 8.533h22V0H0z" clipRule="evenodd" />
      </g>
      <g filter="url(#dawn-flag-AO_svg__e)">
        <path
          fill="#F8D84B"
          fillRule="evenodd"
          d="M12.727 9.242q.197-.35.306-.759c.449-1.707-.546-3.462-2.223-3.919a.523.523 0 0 0-.641.377.534.534 0 0 0 .37.653c1.118.305 1.781 1.475 1.482 2.613a2.2 2.2 0 0 1-.17.441l-1.608-1.092a.52.52 0 0 0-.727.148.54.54 0 0 0 .146.74l1.474 1.001a2.06 2.06 0 0 1-1.682.27.523.523 0 0 0-.641.378.534.534 0 0 0 .37.653 3.1 3.1 0 0 0 2.875-.675l.746.506c.241.164.566.097.727-.148a.54.54 0 0 0-.146-.74zM9.952 6.933c.29 0 .524-.238.524-.533a.53.53 0 0 0-.524-.533.53.53 0 0 0-.524.533c0 .295.235.533.524.533"
          clipRule="evenodd"
        />
      </g>
    </g>
    <defs>
      <filter
        id="dawn-flag-AO_svg__c"
        width={22}
        height={7.467}
        x={0}
        y={8.533}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_88_145" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_88_145" result="shape" />
      </filter>
      <filter
        id="dawn-flag-AO_svg__d"
        width={22}
        height={8.533}
        x={0}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_88_145" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_88_145" result="shape" />
      </filter>
      <filter
        id="dawn-flag-AO_svg__e"
        width={4.824}
        height={7.31}
        x={8.795}
        y={4.546}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_88_145" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_88_145" result="shape" />
      </filter>
      <linearGradient
        id="dawn-flag-AO_svg__b"
        x1={0}
        x2={0}
        y1={0}
        y2={16}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF323E" />
        <stop offset={1} stopColor="#FD0D1B" />
      </linearGradient>
    </defs>
  </svg>
);
export default DawnFlagAO;
